

























import { Component, Vue } from 'vue-property-decorator'
import RouteName from '@/utils/RouteName'

@Component
export default class PublicHeader extends Vue {
    RouteName: typeof RouteName = RouteName
}
